// extracted by mini-css-extract-plugin
module.exports = {"address":"UserAddress_address__2f3MD"};